/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum GroupingOptions {
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
    NONE = 'none',
}
